import React, {ReactElement, useState} from "react"
import {FloatButton} from "antd"
import {useStore} from "@ui/stores"
import Shell from "@ui/icons/common/Shell"
import Menu, {MenuItem} from "./menu"
import Track from "./track"
import Adapter from "./adapter"
import Profile from "./profile"
import Poi from "./poi"
import Layer from "./layer"

const Services = (): ReactElement => {
  const {settings} = useStore()
	const [item, setItem] = useState<MenuItem>()

  const menuItemProps = (menuItem: MenuItem) => ({
    open: () => setItem(menuItem),
    close:  () => setItem(undefined),
    isShow: item === menuItem
  })

	return (
		<>
      <div className="float-buttons">
        <FloatButton
          className="poi"
          icon={<Shell/>}
          shape="square"
          onClick={() => {setItem(item === MenuItem.Layer ? undefined : MenuItem.Layer)}}
          type={item === MenuItem.Layer ? "primary":"default"}
        />
      </div>

			{(item == undefined || settings.isDesktop) && <Menu onCLick={setItem} selected={item} />}
			<Track {...menuItemProps(MenuItem.Track)} />
      <Adapter {...menuItemProps(MenuItem.Adapter)} />
      <Profile {...menuItemProps(MenuItem.Profile)} />
      <Poi {...menuItemProps(MenuItem.Poi)} />
      <Layer {...menuItemProps(MenuItem.Layer)} />
		</>
	)
}

export default Services
